// @ts-expect-error Untyped library
import ScopesList from '../modules/Doc/components/ScopesList';
export default ScopesList;